var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"btn-kakao mb-3",attrs:{"x-large":"","depressed":"","block":"","rounded":""},on:{"click":function($event){return _vm.kakaoLogin()}}},[_vm._v(_vm._s(_vm.btnLabel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }